<script lang="ts">
    import Screen from "../components/shared/Screen.svelte";

    import { setPageTitle } from "../utils";

    setPageTitle("404");
</script>

<Screen>
    <h3 style="max-width: max(700px, 50vw); display: flex;">
        <span style="color: grey; margin-right: 1em; white-space: nowrap;">Шемот 40:4</span>
        <span> И принеси (туда) стол, и расставь на нем посуду, и принеси светильник, и установи на нем лампы. </span>
    </h3>
    <a style="font-size: large; padding: 2em; text-decoration: underline;" href="/">На главную</a>
</Screen>
